import React from 'react';

import FindVetBlock from '@app/components/UI/FindVetBlock/FindVetBlock';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import vetCareCoord from '@app/images/content/Lap-of-love-veterinary-care-coordinator.jpg';
import '@app/scss/components/supportCenter.scss';

const content: Array<{ quote: string; author: string }> = [
	{
		// eslint-disable-next-line max-len
		quote: 'I have two senior dogs of my own, and I understand the importance of a good quality of life for pets at all ages and in all stages. I aim to help people navigate through some of the most difficult times with unwavering compassion and kindness.',
		author: 'Andrea S.',
	},
	{
		quote: 'Being able to assist families during one of their most difficult journeys is a rewarding experience and leaves you feeling fulfilled at the end of the day. Working at Lap of Love, I feel appreciated every single day.',
		author: 'Kaitlyn C.',
	},
	{
		// eslint-disable-next-line max-len
		quote: 'I enjoy working for Lap of Love because of our connections with families while helping them with their fur babies. Everyone who works for Lap of Love is so kind and genuine. It means a lot that Lap of Love cares about the families they help and their employee\'s physical and mental well-being.',
		author: 'Emily L.',
	},
	{
		// eslint-disable-next-line max-len
		quote: 'I love being able to help and guide families through the toughest times. I am the happiest I have ever been at a company. Lap of Love is an amazing company, and I am grateful every day to be part of a team that helps pets and pet families.',
		author: 'Annie D.',
	},
	{
		quote: 'Empathizing and assisting families with losing their beloved pets is such a rewarding role. Lap of Love is the most supportive team of animal lovers!',
		author: 'Jessica K.',
	},
	{
		// eslint-disable-next-line max-len
		quote: 'I have always enjoyed working in customer service and combining that with my passion for animals. At the end of each workday, I leave knowing I have impacted the lives of each family I speak with during one of the hardest calls they have to make. At Lap of Love, we are dedicated to making the hardest day in a pet family’s lives peaceful.',
		author: 'Matt B.',
	},
];

const SupportCenterTeam: React.FC = () => {
	// eslint-disable-next-line max-len
	const mastHeadText = 'Our Veterinary Care Coordinators are here to help, offering guidance and support for one of the hardest phone calls that we, as pet parents, may ever make. You are not alone, we are here for you every day of the week to coordinate and assist every step of the way. ';

	return (
		<HelmetProvider>
			<div className="support-center">
				<Masthead
					title={<>
						{'Support Center of '}
						<br className="space-mobile" />
						Lap of Love
					</>}
					imageSrc={vetCareCoord}
					text={mastHeadText}
					imageAlt="Lap of Love care coordinator"
					buttonText={
						<a href="tel:8559335683" className="btn btn-md btn-primary">
							Contact Us
						</a>
					}
				/>
				<div className="support-center-text">
					<p>
						Lap of Love's Support Center consists of over 200 empathetic and specially trained Veterinary Care Coordinators who are united by
						their commitment to provide unwavering support to pet families as they navigate the challenges of end-of-life pet care. Driven by
						their passion for this vital mission, our dedicated team members stand ready to assist from 7 a.m. to 11 p.m. ET, 365 days a
						year—including weekends and holidays.
					</p>
					<div className="h2">Our Veterinary Care Coordinators find deep fulfillment in helping pet parents in their time of need.</div>
					{content.map((elem, i) => (
						<div key={i}>
							<blockquote>
								<q>{elem.quote}</q>
							</blockquote>
							<ul>
								<li>{elem.author}</li>
							</ul>
						</div>
					))}
				</div>
				<FindVetBlock />
			</div>
		</HelmetProvider>
	);
};

export default SupportCenterTeam;
